import React, { useContext } from "react"
import VizSensor from "react-visibility-sensor"
import ReactMarkdown from "react-markdown"
import remarkGfm from 'remark-gfm';

import { ScrollContext } from "../layout"

import "./highlight.scss"

const Highlight = ({ title, section }) => {
  const [, setFirstBlockVisibility] = useContext(ScrollContext)
  return (
    <VizSensor
      onChange={isVisible => setFirstBlockVisibility(isVisible)}
      partialVisibility
    >
      <section id="portfolio-highlight">
        <div>
          <h1>{title}</h1>
          <div>
            {section.blocks.map((b, i) => (
              <div key={i} className="portfolio-highlight-text">
                <ReactMarkdown children={b.content} remarkPlugins={[remarkGfm]} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </VizSensor>
  )
}

export default Highlight
